import React from 'react';
import { Mail, Phone, ArrowRight } from 'lucide-react';

const GolfContact = () => {
  return (
    <section id="contact" className="py-32 lg:py-40 bg-[#0f2419] relative">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a962]/30 to-transparent" />
      
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        {/* Label */}
        <span className="font-montserrat text-[#c9a962] text-xs tracking-[0.4em] uppercase">
          Contact
        </span>

        {/* Decorative Line */}
        <div className="w-16 h-px bg-[#c9a962] mx-auto my-8" />

        {/* Heading */}
        <h2 className="font-playfair text-4xl lg:text-5xl text-white mb-8">
          Rejoignez <span className="text-[#c9a962] italic">l'exception</span>
        </h2>

        {/* Subtext */}
        <p className="font-montserrat text-lg text-white/60 font-light mb-16 max-w-xl mx-auto">
          Contactez notre bureau de vente pour une présentation privée.
        </p>

        {/* Contact Info - Centered & Minimal */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-12 mb-16">
          {/* Email */}
          <a 
            href="mailto:contact@onegreendev.com"
            className="flex items-center gap-4 group"
          >
            <div className="w-14 h-14 rounded-full border-2 border-[#c9a962]/50 flex items-center justify-center group-hover:bg-[#c9a962] group-hover:border-[#c9a962] transition-all duration-300">
              <Mail className="w-5 h-5 text-[#c9a962] group-hover:text-[#0f2419] transition-colors" />
            </div>
            <div className="text-left">
              <p className="font-montserrat text-white/40 text-xs tracking-wider uppercase mb-1">Email</p>
              <p className="font-montserrat text-white group-hover:text-[#c9a962] transition-colors">
                contact@onegreendev.com
              </p>
            </div>
          </a>

          {/* Divider */}
          <div className="hidden sm:block w-px h-12 bg-[#c9a962]/20" />

          {/* Phone */}
          <a 
            href="tel:+2250705509738"
            className="flex items-center gap-4 group"
          >
            <div className="w-14 h-14 rounded-full border-2 border-[#c9a962]/50 flex items-center justify-center group-hover:bg-[#c9a962] group-hover:border-[#c9a962] transition-all duration-300">
              <Phone className="w-5 h-5 text-[#c9a962] group-hover:text-[#0f2419] transition-colors" />
            </div>
            <div className="text-left">
              <p className="font-montserrat text-white/40 text-xs tracking-wider uppercase mb-1">Téléphone</p>
              <p className="font-montserrat text-white group-hover:text-[#c9a962] transition-colors">
                +225 07 05 50 97 38
              </p>
            </div>
          </a>
        </div>

        {/* CTA Button */}
        <a
          href="mailto:contact@onegreendev.com?subject=Demande%20de%20pr%C3%A9sentation%20priv%C3%A9e%20-%20Golf%20de%20Songon"
          className="inline-flex items-center gap-3 btn-gold px-10 py-5 text-sm uppercase tracking-widest"
        >
          Demander une présentation
          <ArrowRight className="w-4 h-4" />
        </a>

        {/* Decorative Element */}
        <div className="flex items-center justify-center gap-4 mt-20">
          <div className="w-12 h-px bg-[#c9a962]/30" />
          <div className="w-2 h-2 bg-[#c9a962] rotate-45" />
          <div className="w-12 h-px bg-[#c9a962]/30" />
        </div>

        {/* One Green Dev Mention */}
        <p className="font-montserrat text-white/30 text-xs tracking-wider uppercase mt-10">
          Un projet One Green Dev
        </p>
      </div>
    </section>
  );
};

export default GolfContact;
